import { useState } from 'react';

import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { prepareFilter } from 'libs/common';
import { PromisesGrid } from './grid';
import Filter from './filter';

const sortInitial = [{ field_name: 'id', direction: 'desc' }];
const itemsInitial = {};

export const Promises = (props) => {
  const [items, setItems] = useState(itemsInitial);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('promise', sortInitial);

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    // console.log('🚀 ~ prepareParams ~ data:', data);
    if (!data) {
      return data;
    }
    const dataOk = { ...data };
    const key = 'is_payed';
    if (data[key] === 'payed') {
      dataOk[key] = true;
    } else if (data[key] === 'notpayed') {
      dataOk[key] = false;
    }

    const addParams = {};
    return prepareFilter(dataOk, addParams, {});
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    clearEntries: () => setItems({}),
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return (
    <Controller
      {...props}
      {...gridParams}
      {...gridActions}
      type="promise_pay"
      filterName="promise_payFilter"
      grid={PromisesGrid}
      gridFilter={Filter}
      getRequestParams={prepareParams}
    />
  );
};
